import React from 'react';
import { Star } from 'lucide-react';
interface StarRatingProps {
  size?: number;
  className?: string;
}
export function StarRating({
  size = 16,
  className = ''
}: StarRatingProps) {
  return <div className={`flex gap-0.5 ${className}`} data-id="element-29">
      {[1, 2, 3, 4, 5].map(star => <Star key={star} size={size} className="fill-amber-400 text-amber-400" data-id="element-30" />)}
    </div>;
}